import { ScatterplotLayer } from 'deck.gl';
import { PARAMETROS_MARCADOR, PARAMETROS_ADITIVOS } from './pulso';
import { COLORES_TIPO } from './destinos';

// Servicios alcanzables desde los principales destinos de trabajo de los
// residentes de la celda elegida (segundo orden real). En vez de un anillo rojo
// duro, cada servicio lleva un halo calido aditivo por debajo: marca "tambien
// alcanzable desde el trabajo" sin competir con el color del tipo. Si un
// servicio ya se veia desde la casa, el punto de destinos.js queda sobre el
// halo: doble cobertura.
const COLOR_APAGADO = [42, 42, 51];
const COLOR_HALO = [255, 120, 70];
const RADIO_DOT = 4.5;
const RADIO_HALO_MIN = 7;
const RADIO_HALO_MAX = 12;

function infoActiva(alcanzablesSegundoOrden, idx, t) {
  const info = alcanzablesSegundoOrden.get(idx);
  return info && info.minutos <= t ? info : null;
}

// "candidatos" es el subconjunto de amenities alcanzables desde algun destino
// de trabajo, memoizado en App: filtrar los 4.659 amenities aqui lo repetiria
// dos veces por frame (halo y punto).

// Halo calido bajo los puntos: el brillo y el radio siguen el peso del destino
// de trabajo que alcanza el servicio.
export function construyeCapaGlowSegundoOrden({ candidatos, alcanzablesSegundoOrden, t }) {
  if (!alcanzablesSegundoOrden || alcanzablesSegundoOrden.size === 0) return null;
  const data = candidatos;
  if (!data || data.length === 0) return null;

  return new ScatterplotLayer({
    id: 'glow-segundo-orden',
    data,
    pickable: false,
    radiusUnits: 'pixels',
    stroked: false,
    filled: true,
    parameters: PARAMETROS_ADITIVOS,
    getPosition: (d) => [d.lon, d.lat],
    getRadius: (d) => {
      const info = infoActiva(alcanzablesSegundoOrden, d.idx, t);
      if (!info) return 0;
      return RADIO_HALO_MIN + info.pesoRelativo * (RADIO_HALO_MAX - RADIO_HALO_MIN);
    },
    getFillColor: (d) => {
      const info = infoActiva(alcanzablesSegundoOrden, d.idx, t);
      if (!info) return [0, 0, 0, 0];
      return [...COLOR_HALO, Math.round(45 + info.pesoRelativo * 70)];
    },
    updateTriggers: {
      getRadius: [alcanzablesSegundoOrden, t],
      getFillColor: [alcanzablesSegundoOrden, t],
    },
  });
}

// Punto del servicio en el color de su tipo (mismo catalogo que destinos.js),
// sin borde. Es el que hace visibles los servicios que solo se alcanzan desde
// el trabajo (destinos.js no los enciende porque no llegan desde la casa).
export function construyeCapaDestinosSegundoOrden({ candidatos, alcanzablesSegundoOrden, t }) {
  if (!alcanzablesSegundoOrden || alcanzablesSegundoOrden.size === 0) return null;
  const data = candidatos;
  if (!data || data.length === 0) return null;

  return new ScatterplotLayer({
    id: 'destinos-segundo-orden',
    data,
    pickable: false,
    radiusUnits: 'pixels',
    stroked: false,
    filled: true,
    parameters: PARAMETROS_MARCADOR,
    getPosition: (d) => [d.lon, d.lat],
    getRadius: (d) => (infoActiva(alcanzablesSegundoOrden, d.idx, t) ? RADIO_DOT : 0),
    getFillColor: (d) => {
      const info = infoActiva(alcanzablesSegundoOrden, d.idx, t);
      if (!info) return [0, 0, 0, 0];
      const opacidad = Math.round(150 + info.pesoRelativo * 90);
      return [...(COLORES_TIPO[d.tipo] ?? COLOR_APAGADO), opacidad];
    },
    updateTriggers: {
      getRadius: [alcanzablesSegundoOrden, t],
      getFillColor: [alcanzablesSegundoOrden, t],
    },
  });
}
